import React, { useState, useEffect } from "react";

const FallbackImage = ({ children, imageUrl, ...props }) => {
  const [imageValid, setImageValid] = useState(null);

  useEffect(() => {
    if (!imageUrl) {
      setImageValid(false);
      return;
    }

    const img = new Image();
    img.onload = () => setImageValid(true);
    img.onerror = () => setImageValid(false);
    img.src = imageUrl;
  }, [imageUrl]);

  if (imageValid === false) {
    return children;
  }

  return <div className="menu-image" {...props} aria-hidden="true" />;
};

export default FallbackImage;
